import { createStyles } from '@mantine/core';

import { useDisclosure } from '@mantine/hooks';
import useTranslation from 'next-translate/useTranslation';
import { Button } from '~/domains/design-system/Button';
import { ContainerNested } from '~/domains/design-system/Container';
import { Text } from '~/domains/design-system/Text';
import type { PublicBoost } from '../../../services/interfaces/propsService/api/boosts';
import BoostBanner from './BoostBannerButton';
import BoostsAvailableModal from './modals/BoostsAvailableModal';

export const useStyles = createStyles((theme) => ({
  header: {
    height: theme.other.spacing._16,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },
  container: {
    display: 'flex',
    overflowX: 'auto',
    gap: theme.other.spacing._8,
    marginBottom: -theme.other.spacing._16,
  },
  viewAllButton: {
    whiteSpace: 'nowrap',
    height: 75,
  },
}));

function Boosts({ boosts }: { boosts: PublicBoost[] }) {
  const { classes } = useStyles();
  const [isOpen, { open, close }] = useDisclosure();
  const { t } = useTranslation('contest');
  const MAX_BOOSTS_TO_SHOW = 3;

  const boostsToShow = boosts.slice(0, MAX_BOOSTS_TO_SHOW);

  return (
    <>
      <ContainerNested className={classes.container}>
        {boostsToShow.map((boost) => (
          <BoostBanner
            key={boost.id}
            id={boost.id}
            title={boost.title}
            description={boost.description}
            expiresAt={boost.expires_at}
            callout={boost.callout}
            terms={boost.terms}
            icon={boost.svg_url}
          />
        ))}
        {boosts.length > MAX_BOOSTS_TO_SHOW && (
          <Button onClick={open} variant="text" className={classes.viewAllButton}>
            <Text fw={600} color="splash.5" variant="title-small">
              {t('quickPick.boost.viewAll')}
            </Text>
          </Button>
        )}
      </ContainerNested>
      <BoostsAvailableModal isOpen={isOpen} onClose={close} />
    </>
  );
}

export default Boosts;
